import React from 'react';
import { Link } from 'react-router-dom';
import { pathManager } from 'routes';

import { Box, Avatar, Typography } from '@mui/material';

import { SmsConversationType } from '../types';

interface SmsChatHeaderProps {
  conversation: SmsConversationType;
}

const SmsChatHeader: React.FC<SmsChatHeaderProps> = ({ conversation }) => {
  const firstName = conversation.talent?.first_name_abac?.value || '';
  const lastName = conversation.talent?.last_name_abac?.value || '';
  const talentName = `${firstName} ${lastName}`.trim() || 'Unknown';
  const phoneNumber = conversation.talent?.talent_data?.phone || 'No phone';
  const avatar = conversation.talent?.avatar?.avatar;
  const profilePath = pathManager.company.talentProfile.generatePath({
    id: conversation.talent.id,
  });

  return (
    <Box
      px={4}
      py={3}
      borderBottom="1px solid #E0E0E0"
      display="flex"
      alignItems="center"
    >
      <Link to={profilePath} style={{ textDecoration: 'none' }}>
        <Avatar
          src={avatar || undefined}
          sx={{
            width: 48,
            height: 48,
            mr: 2,
            bgcolor: '#222',
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.8,
            },
          }}
        >
          {talentName.charAt(0).toUpperCase()}
        </Avatar>
      </Link>
      <Box>
        <Link
          to={profilePath}
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Typography
            fontWeight={600}
            fontSize={18}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            {talentName}
          </Typography>
        </Link>
        <Typography fontSize={14} color="text.secondary">
          {phoneNumber}
        </Typography>
      </Box>
    </Box>
  );
};

export default SmsChatHeader;
